<script setup>
import {useRoute, useRouter} from 'vue-router'
const route = useRoute()

</script>

<template>
  <router-view v-slot="{ Component }">
    <transition name="fade-transform" mode="out-in">
      <div class="container-wrap" :key="route.path">
        <component :is="Component"></component>
      </div>
    </transition>
  </router-view>
</template>

<style scoped lang="less">
@import 'index.less';
</style>
